/**
 * File frontpage-countdown.js
 *
 * Handles the Countdown functionality and content for the homepage countdown.
 */
/* prettier-ignore */
/* eslint-disable no-console, no-unused-vars */
document.addEventListener( 'DOMContentLoaded', function () {
  if (
    document.querySelectorAll( '.banner-carousel.countdown' ).length &&
    document.querySelectorAll( '.banner-carousel.countdown .timer' ).length &&
    document.querySelectorAll( '.banner-carousel.countdown .slide-content' ).length &&
    document.querySelectorAll( '.banner-carousel.countdown .slide-content .fader' ).length &&
    document.querySelectorAll( '.banner-carousel.countdown .carousel-background' ).length
  ) {
    const timerEl      = document.querySelector( '.banner-carousel.countdown .timer' );
    const color        = timerEl.getAttribute( 'data-color' ) ?? 'text';
    const expires      = timerEl.getAttribute( 'data-expires' );
    const msExpires    = parseInt( expires ) * 1000;
    const dateExpires  = new Date( msExpires );

    const timer = setInterval( function() {
      // Get today's date and time
      const now  = Date.now();

      // Find the distance between now and the count down date
      const diff = dateExpires - now;

      // Time calculations for days, hours, minutes and seconds
      const segments = {
        days:    Math.floor( diff / ( 1000 * 60 * 60 * 24 ) ),
        hours:   Math.floor( ( diff % ( 1000 * 60 * 60 * 24 ) ) / ( 1000 * 60 * 60 ) ),
        minutes: Math.floor( ( diff % ( 1000 * 60 * 60 ) ) / ( 1000 * 60 ) ),
        seconds: Math.floor( ( diff % ( 1000 * 60 ) ) / 1000 ),
      }

      let i = 0;
      let timerHTML = '';
      for ( const label of Object.keys( segments ) ) {
        if ( i > 0 ) {
          timerHTML += '<span class="separator"></span>';
        }

        const segmentValues = segments[ label ].toString().padStart( 2, '0' ).split( '' );

        let segmentDigits = '';
        for ( const segmentDigit of segmentValues ) {
          segmentDigits += `<span class="digit">${segmentDigit}</span>`
        }

        timerHTML += `<span class="segment ${label}">
            <span class="digits has-${color}-color">${segmentDigits}</span>

            <small class="label">${label}</small>
          </span>`;

        i++;
      }

      timerEl.innerHTML = timerHTML;

      // If the count down is over, replace the content via API call.
      if ( diff <= 1500 ) {
        clearInterval( timer );
        updateExpiredCountdownContent();
      }
    }, 1000);

    async function updateExpiredCountdownContent () {
      const bannerEl = document.querySelector( '.banner-carousel.countdown' );
      const faderEl  = document.querySelector( '.banner-carousel.countdown .slide-content .fader' );
      const bgEl     = document.querySelector( '.banner-carousel.countdown .carousel-background' );
      const url      = '/wp-json/live/countdown/';

      try {
        faderEl.classList.add( 'loading' );

        bannerEl.classList.remove( 'phase-before' );
        bannerEl.classList.add( 'phase-after' );

        const response = await fetch(url);

        if ( ! response.ok ) {
          location.reload();
        }

        const json        = await response.json();
        const resultBG    = json.background;
        const resultHTML  = json.html;

        bgEl.insertAdjacentHTML( 'beforeend', resultBG );
        faderEl.innerHTML = resultHTML;

        faderEl.classList.remove( 'loading' );
      } catch (error) {
        console.error( error.message );

        faderEl.classList.remove( 'loading' );
      }
    }
  }
} );
/* eslint-enable no-console, no-unused-vars */
